import { MenuButton, TableColumn, TableRow, CircularProgress } from 'react-md'
import type { PurchaseInvoice, PurchaseInvoiceHeader } from './types'
import { purchaseInvoiceTableHeaders } from './constants'
import StatusChip from './Dialog/StatusChip'
import { purchaseInvoiceStatusFromState } from '../utils/messages'

type Props = {
	loading?: boolean
	hideActions?: boolean
	purchaseInvoice: PurchaseInvoice
	menuItems: any[] | null
	children: any
	processing: any
	handleOnClick: () => void
}

const PurchaseInvoiceRow = ({
	loading = false,
	hideActions = false,
	purchaseInvoice,
	menuItems,
	children,
	processing,
	handleOnClick,
}: Props) => {
	const appendedMenuItems = menuItems ? [...menuItems] : null

	const menu = !appendedMenuItems ? null : (
		<MenuButton
			id={'menu-button'}
			icon
			menuItems={appendedMenuItems}
			disabled={processing || loading}
			centered
			anchor={{
				x: MenuButton.HorizontalAnchors['CENTER'],
				y: MenuButton.VerticalAnchors['CENTER'],
			}}
		>
			more_vert
		</MenuButton>
	)

	const getRowValue = (header: PurchaseInvoiceHeader) => {
		let value = purchaseInvoice[header.key]
		if (header.type === 'date') {
			return new Date(value as any).toLocaleDateString()
		} else if (header.type === 'status') {
			return (
				<StatusChip
					status={purchaseInvoiceStatusFromState(
						purchaseInvoice.state,
						purchaseInvoice.dueDate,
					)}
				/>
			)
		} else {
			return value as any
		}
	}

	const renderTableColumns = () => {
		return purchaseInvoiceTableHeaders
			.filter((h) => h.show)
			.map((header) => {
				return (
					<TableColumn
						style={{ opacity: loading ? 0.5 : 1 }}
						onClick={handleOnClick}
						key={header.key}
					>
						<p>{getRowValue(header)}</p>
					</TableColumn>
				)
			})
	}

	return (
		<TableRow key={purchaseInvoice.id}>
			{renderTableColumns()}
			{hideActions ? null : (
				<TableColumn key={'children'}>
					<div>
						{processing ? (
							<CircularProgress id="progress" style={{ marginTop: 0 }} />
						) : (
							menu
						)}
						{children}
					</div>
				</TableColumn>
			)}
		</TableRow>
	)
}

export default PurchaseInvoiceRow
